import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import JEEMainsImage from '../images/goals/jee-mains.svg';
import {useState} from 'react';
import {padhaai_url} from '../config';
import {HtmlDecode} from '../utils/handle-session'
export default function Folder({folder,subcategory}) {
    const [showModal, setShowModal] = useState(false);
	const myLoader = ({src}) => {
		return `${src}`;
	};
	return (
        <>
		<div className="xl:w-1/4 lg:w-1/3 sm:w-1/2 px-3 mb-6 w-full">
			<div className="shadow-card p-[10px] rounded-xl flex items-center cursor-pointer bg-white hover:scale-105 hover:z-50 transition-all ease-in-out" onClick={() => setShowModal(true)}>
				<Image loader={myLoader} src={subcategory.logo.data!==null?subcategory.logo.data.attributes.url:JEEMainsImage} alt="" width={50} height={50} />
				<span className="text-black font-medium text-sm ml-4">{HtmlDecode(folder.attributes!=null?folder.attributes.name:subcategory.name)}</span>
			</div>
		</div>
        {showModal ? (
				<>
					<div onClick={() => setShowModal(false)} className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
						<div className="relative my-6 xl:w-1/3 md:w-9/12 w-11/12">
							{/*content*/}
							<div className="border-0 shadow-lg relative flex flex-col w-full bg-white rounded-xl outline-none focus:outline-none">
								{/*body*/}
								<div className="relative p-6 flex-auto">
									<h4 className="text-center lg:text-3xl ms:text-2xl text-xl font-medium mb-3">Pick a goal language</h4>
									<p className="text-center text-black mb-4">Courses in the preferred language will be shown first</p>
									<ul>
										<li className="grid grid-cols-2 gap-4">
										   <Link href={`${padhaai_url}/padhaai-gurucool/subcategory/${subcategory.slug}${(folder.attributes!=null?`?topic=${folder.id}&language=all`:`?language=all`)}`}>
												<a className="bg-[#FFF9E4] px-6 py-8 relative w-[100%] sm:h-[200px] h-[150px] flex justify-center items-center overflow-hidden rounded-xl">
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:top-[-25px] top-0 md:leading-none md:left-[-10px] left-0">G</h2>
													<h3 className="text-xl text-black font-medium mb-3">All</h3>
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:bottom-[-20px] bottom-0 leading-none right-0">उ</h2>
												</a>
											</Link>
											<Link href={`${padhaai_url}/padhaai-gurucool/subcategory/${subcategory.slug}${(folder.attributes!=null?`?topic=${folder.id}&language=hinglish`:`?language=hinglish`)}`}>
												<a className="bg-[#FFF9E4] px-6 py-8 relative w-[100%] sm:h-[200px] h-[150px] flex justify-center items-center overflow-hidden rounded-xl">
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:top-[-25px] top-0 md:leading-none md:left-[-10px] left-0">G</h2>
													<h3 className="text-xl text-black font-medium mb-3">Hinglish</h3>
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:bottom-[-20px] bottom-0 leading-none right-0">उ</h2>
												</a>
											</Link>
											
											<Link href={`${padhaai_url}/padhaai-gurucool/subcategory/${subcategory.slug}${(folder.attributes!=null?`?topic=${folder.id}&language=english`:`?language=hindi`)}`}>
												<a className="bg-[#FFF9E4] px-6 py-8 relative w-[100%] sm:h-[200px] h-[150px] flex justify-center items-center overflow-hidden rounded-xl">
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:top-[-25px] top-0 md:leading-none md:left-[-10px] left-0">H</h2>
													<h3 className="text-xl text-black font-medium mb-3">Hindi</h3>
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:bottom-[-20px] bottom-0 leading-none right-0">र</h2>
												</a>
											</Link>
											<Link href={`${padhaai_url}/padhaai-gurucool/subcategory/${subcategory.slug}${(folder.attributes!=null?`?topic=${folder.id}&language=english`:`?language=english`)}`}>
												<a className="bg-[#FFF9E4] px-6 py-8 relative w-[100%] sm:h-[200px] h-[150px] flex justify-center items-center overflow-hidden rounded-xl">
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:top-[-25px] top-0 md:leading-none md:left-[-10px] left-0">G</h2>
													<h3 className="text-xl text-black font-medium mb-3">English</h3>
													<h2 className="lg:text-[120px] md:text-[80px] ms:text-[60px] text-[40px] text-[#FFCD83] font-medium absolute md:bottom-[-20px] bottom-0 leading-none right-0">उ</h2>
												</a>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</>
			) : null}
        </>
	);
}
